import React, { useEffect, useState } from 'react';
import { Container, Grid, Typography } from '@mui/material';
import moment from 'moment';
import { summaryReportHeaderKpi } from 'api';
import { isCarrierLogin } from 'tools/auth';
import { reportException } from 'tools/logs';
import { HeaderKpi } from 'interfaces/ISummaryReport';
import { formatCompactNumber, formatDateMMDDYYYY } from 'tools/helper';
import strings from 'strings';
import SummaryCard from './SummaryCard';
import { TypoGraph } from 'components';

const r = strings.SUMMARY_REPORT;
const t = r.SUMMARY_CARDS;
interface ICarrierHeaderKPIs {
}

const CarrierHeaderKPIs: React.FC<ICarrierHeaderKPIs> = (props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [headerKpi, setHeaderKpi] = useState<HeaderKpi | null>(null);
    const carrierId: any = isCarrierLogin() ? localStorage.getItem('companyId') : localStorage.getItem('carrierId') || '1';
    const codeType: any = localStorage.getItem('carrierCodeType') || 1;
    const codeValue: any = localStorage.getItem('carrierCodeValue') || 1;
    const eldVendor: any = localStorage.getItem('eldProviderRisk') || 1;

    useEffect(() => {
        setIsLoading(true);
        summaryReportHeaderKpi(carrierId, codeType, codeValue, eldVendor)
            .then((res: any) => {
                setHeaderKpi(res);
            })
            .catch((error: any) => {
                reportException(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    const calculatedOnText = `${r.CALCULATED_ON}${headerKpi?.riskExecutionDate ? formatDateMMDDYYYY(headerKpi?.riskExecutionDate) : '-'} 
        ${r.DAYS_OF_DATA_PRE} ${headerKpi?.riskEndingDate && headerKpi?.riskStartingDate ? 
            moment(headerKpi?.riskEndingDate).diff(moment(headerKpi?.riskStartingDate), 'days') : 0} 
            ${r.DAYS_OF_DATA_POST}`;

    return (
        <>
            <TypoGraph
                variant="h2"
                sx={{ marginRight: '1rem' }}
                mb={0}
                content={t.HEADER_KPIS_TITLE}
            />
            <TypoGraph variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                {calculatedOnText}
            </TypoGraph>
            <Grid container spacing={2} justifyContent="center" sx={{ mb: 2, mt: 1 }}>
                <SummaryCard
                    id="summary-card-active-vehicles"
                    isLoading={isLoading}
                    icon="LocalShippingOutlined"
                    iconColor="#1c2230"
                    value={headerKpi?.activeVehicles?.toLocaleString('en-US')}
                    title={t.ACTIVE_VEHICLES}
                    subtitle={`${t.ON_POLICY}: ${headerKpi?.onPolicyVehicles === 0 ? '0' : headerKpi?.onPolicyVehicles ?? '-'}`}
                />
                <SummaryCard
                    id="summary-card-total-miles"
                    isLoading={isLoading}
                    icon="LocationOnOutlined"
                    iconColor="#a559ea"
                    value={headerKpi?.totalMiles ? formatCompactNumber(headerKpi?.totalMiles) : null}
                    tooltipText={headerKpi?.totalMiles?.toLocaleString('en-US')}
                    title={t.TOTAL_MILES}
                    subtitle={`${t.AVG_PER_UNIT}: ${headerKpi?.averageMilesPerUnit?.toFixed(2) ?? '-'}`}
                />
                <SummaryCard
                    id="summary-card-risk-score"
                    isLoading={isLoading}
                    icon="AccessTime"
                    iconColor="#51c17d"
                    value={headerKpi?.riskScore ? headerKpi?.riskScore?.toFixed(2) : '-'}
                    tooltipText={headerKpi?.riskScore ? headerKpi?.riskScore?.toString() : '-'}
                    title={t.RISK_SCORE}
                    subtitle={`${t.NATIONAL_AVG}: ${headerKpi?.averageRiskScore?.toFixed(2) ?? '-'}`}
                    borderColor="#51c17d"
                    bgColor="#f1fdf5"
                />
                <SummaryCard
                    id="summary-card-harsh-events"
                    isLoading={isLoading}
                    icon="ShieldOutlined"
                    iconColor="#51c17d"
                    value={headerKpi?.harshEventsIndex ? headerKpi?.harshEventsIndex?.toFixed(2) : '-'}
                    tooltipText={headerKpi?.harshEventsIndex ? headerKpi?.harshEventsIndex?.toString() : '-'}
                    title={t.HARSH_EVENTS_INDEX}
                    subtitle={`${t.NATIONAL_AVG}: ${headerKpi?.averageHarshEventsIndex?.toFixed(2) ?? '-'}`}
                    borderColor="#51c17d"
                    bgColor="#f1fdf5"
                />
                <SummaryCard
                    id="summary-card-speeding-index"
                    isLoading={isLoading}
                    icon="TrendingUp"
                    iconColor="#51c17d"
                    value={headerKpi?.speedIndex ? headerKpi?.speedIndex?.toFixed(2) : '-'}
                    tooltipText={headerKpi?.speedIndex ? headerKpi?.speedIndex?.toString() : '-'}
                    title={t.SPEEDING_INDEX}
                    subtitle={`${t.NATIONAL_AVG}: ${headerKpi?.averageSpeedIndex?.toFixed(2) ?? '-'}`}
                    borderColor="#51c17d"
                    bgColor="#f1fdf5"
                />
                <SummaryCard
                    id="summary-card-geographic-index"
                    isLoading={isLoading}
                    icon="MapOutlined"
                    iconColor="#51c17d"
                    value={headerKpi?.geographicalIndex ? headerKpi?.geographicalIndex?.toFixed(2) : '-'}
                    tooltipText={headerKpi?.geographicalIndex ? headerKpi?.geographicalIndex?.toString() : '-'}
                    title={t.GEOGRAPHIC_INDEX}
                    subtitle={`${t.NATIONAL_AVG}: ${headerKpi?.averageGeographicalIndex?.toFixed(2) ?? '-'}`}
                    borderColor="#51c17d"
                    bgColor="#f1fdf5"
                />

                <Grid item xs={12}>
                    <TypoGraph variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center', mt: 1, fontStyle: 'italic' }}>
                        {t.HELP_TEXT}
                    </TypoGraph>
                </Grid>
            </Grid>
        </>
    );
}

export default CarrierHeaderKPIs;